import * as React from 'react'

import { observer } from 'mobx-react'

import {
  ILocationClosureInterval,
  IProjectClosedInterval,
} from '~/client/graph'
import DateClosuresCell from '~/client/src/shared/components/ResourceControls/cells/DateClosuresCell'
import ClosuresStore from '~/client/src/shared/stores/domain/Closures.store'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

interface IProps {
  recordId: string
  closuresStore: ClosuresStore
  projectDateStore: ProjectDateStore
  isBookable: boolean
  onSave: (interval: ILocationClosureInterval, closureId?: string) => void
  onRemove: (closureId: string) => void
  inheritedClosures?: IProjectClosedInterval[]
  onEditProjectClosures?: () => void
}

function StoreBackedDateClosuresCell({
  recordId,
  closuresStore,
  projectDateStore,
  isBookable,
  onSave,
  onRemove,
  inheritedClosures,
  onEditProjectClosures,
}: IProps) {
  return (
    <DateClosuresCell
      closures={closuresStore.getLocationActiveClosures(recordId)}
      projectDateStore={projectDateStore}
      isBookable={isBookable}
      onSave={onSave}
      onRemove={onRemove}
      inheritedClosures={inheritedClosures}
      onEditProjectClosures={onEditProjectClosures}
    />
  )
}

export default observer(StoreBackedDateClosuresCell)
